import script from "./ViewHtmlOcupacoesSolo.vue?vue&type=script&setup=true&lang=js"
export * from "./ViewHtmlOcupacoesSolo.vue?vue&type=script&setup=true&lang=js"

import "./ViewHtmlOcupacoesSolo.vue?vue&type=style&index=0&id=51a15f85&scoped=true&lang=css"

import exportComponent from "../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-51a15f85"]])

export default __exports__